import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';

const DraggableComponent = ({ draggableId = '', index = 0, children }) => {
  return (
    <Draggable draggableId={draggableId} index={index}>
      {(dragProvided) => {
        const childrenWithProps = React.Children.map(children, (child) =>
          React.cloneElement(child, {
            dragHandleProps: dragProvided.dragHandleProps,
          }),
        );
        return (
          <div ref={dragProvided.innerRef} {...dragProvided.draggableProps}>
            {/* beautiful dnd requires these props as a child but we want props passed down so the grabber only works */}
            <input type='hidden' {...dragProvided.dragHandleProps} />
            {childrenWithProps}
          </div>
        );
      }}
    </Draggable>
  );
};

DraggableComponent.propTypes = {
  draggableId: PropTypes.string,
  index: PropTypes.number,
  children: PropTypes.node,
};

export default DraggableComponent;
